import { Component, computed, inject } from '@angular/core';
import { LoaderService } from '../../services/loader/loader.service';
import { CacheService } from '../../ssr-services/cache/cache.service';

@Component({
  selector: 'app-loader',
  imports: [],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
})
export class LoaderComponent {
  private readonly loaderService = inject(LoaderService);

  protected cacheService = inject(CacheService);

  public isLoading = computed(() => this.loaderService.isLoading());

  public s3BucketAssets = computed(
    () => this.cacheService.cachedContent()?.cache?.config?.webAppConfig?.s3BucketAssets
  );
}
